Ext.define('SA.ModeStates', {
    constructor() {
        var view = SA.ActiveState.createInactive(),
            edit = SA.ActiveState.createInactive();

        this.states = {view, edit};
        this.observable = new Ext.util.Observable();

        view.onFirstActive(() => this.observable.fireEvent('viewMode:firstActive', view));
        edit.onFirstActive(() => this.observable.fireEvent('editMode:firstActive', edit));
    },

    activate(mode) {
        this.states[mode].activate();
    },

    deactivate() {
        this.getActive().deactivate();
    },

    get(predicate) {
        return Object.values(this.states).find(state => predicate(state));
    },

    getActive() {
        return this.get(state => state.isActive());
    },

    onModeFirstActive(mode, callback, scope) {
        var event = mode === 'view' ? 'viewMode:firstActive' : 'editMode:firstActive';

        this.observable.on(event, callback, scope);
    },

    switchMode() {
        var activeMode = this.getActive(),
            inactiveMode = this.get(state => !state.isActive());

        activeMode.deactivate();
        inactiveMode.activate();
    }
});